function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M211,27.6c-8.4-10-16.4-19.2-23.6-27.6c-7.2,8.8-15.2,18-23.6,27.6C113,86,43,167.2,43,230.4c0,40,16,76,42.4,102 c26,26,62,42.4,102,42.4s76-16,102-42.4c26-26,42.4-62.4,42.4-102C331.8,167.2,261.8,86.4,211,27.6z M276.2,310.8 c-5.6,1.2-10.8-2.4-12-8l-0.8-7.2c0,0-15.1,14.5-21.6,19.2c-14.6,10.5-33.2,15.2-52,15.2c-26.8,0-50.8-10.8-68.4-28.4 C103.8,284,93,260,93,233.2c0-6,4.4-10.4,10-10.4c5.6,0,10,4.4,10,10c0,21.2,8.4,40.4,22.4,54c14,14,32.8,22.4,54,22.4 c14.8,0,29.2-4.4,41.2-12c5.9-3.7,16-13.6,16-13.6l-8.8,1.6c-5.6,1.2-10.8-2.4-12-8c-1.2-5.6,2.4-10.8,8-12l32-6.4 c5.6-1.2,10.8,2.4,12,8l6.4,32C285.4,304.4,281.8,309.6,276.2,310.8z M275,243.2c-5.6,0-10-4.4-10-10c0-21.2-8.4-40.4-22.4-54 c-14-14-32.8-22.4-54-22.4c-14.8,0-29.2,4.4-41.2,12c-6,3.6-11.2,8.4-16,13.6l8.8-1.6c5.6-1.2,10.8,2.4,12,8 c1.2,5.6-2.4,10.8-8,12l-32,6.4c-5.6,1.2-10.8-2.4-12-8l-6.4-32c-1.6-6,2-11.6,7.2-12.4c5.6-1.2,10.8,2.4,12,8l1.6,7.6 c6.4-7.2,13.6-13.6,21.6-18.8c15.2-9.6,33.2-15.2,52-15.2c26.8,0,50.8,10.8,68.4,28.4c17.6,17.6,28.4,41.6,28.4,68.4 C285,238.8,280.6,243.2,275,243.2z"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var _ref17 =
/*#__PURE__*/
React.createElement("g", null);

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 374.8 374.8",
    style: {
      enableBackground: "new 0 0 374.8 374.8"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.d4ef380e.svg";
export { ForwardRef as ReactComponent };